/**
 * Plan symbols for the inspection report's drawings
 * (claude-docs/2026-10-15-inspection-report-items-design.md): a fixed item drawn
 * in its own turned frame, in light grey, the way a floor plan draws fixtures;
 * a device as a small electrical-plan mark. SVG strings in screen pixels,
 * colours handed in by `planSvg`. Pure.
 */

const f1 = (v) => v.toFixed(1);

/** A device's mark at (`px`, `py`), by its tag letters (`inspectionItems.DEVICE_TAGS`). */
function deviceSvg(letters, px, py, colors) {
  const c = colors.device;
  const circle = (r, fill = colors.fixture) =>
    `<circle cx="${f1(px)}" cy="${f1(py)}" r="${r}" fill="${fill}" stroke="${c}" stroke-width="0.9"/>`;
  const seg = (x1, y1, x2, y2) =>
    `<line x1="${f1(px + x1)}" y1="${f1(py + y1)}" x2="${f1(px + x2)}" y2="${f1(py + y2)}" stroke="${c}" stroke-width="0.9"/>`;
  const letter = (t) =>
    `<text x="${f1(px)}" y="${f1(py)}" text-anchor="middle" dominant-baseline="central" font-size="7" font-weight="700" fill="${c}">${t}</text>`;
  switch (letters) {
    case 'R': // a duplex outlet: a circle, two parallel slots
      return (
        circle(4.5) + seg(-1.5, -2.5, -1.5, 2.5) + seg(1.5, -2.5, 1.5, 2.5)
      );
    case 'SW':
      return letter('S');
    case 'L': // a light: a circle crossed
      return (
        circle(4.5) + seg(-3.2, -3.2, 3.2, 3.2) + seg(-3.2, 3.2, 3.2, -3.2)
      );
    case 'FN':
      return (
        circle(4.5) + seg(0, 0, 0, -4) + seg(0, 0, 3.5, 2) + seg(0, 0, -3.5, 2)
      );
    case 'V':
      return `<rect x="${f1(px - 5)}" y="${f1(py - 3)}" width="10" height="6" fill="${colors.fixture}" stroke="${c}" stroke-width="0.9"/>${seg(-3, -1, 3, -1)}${seg(-3, 1, 3, 1)}`;
    case 'D':
      return circle(4.5) + letter('D');
    case 'P':
      return circle(3, c);
    default:
      return `<rect x="${f1(px - 3)}" y="${f1(py - 3)}" width="6" height="6" fill="${colors.fixture}" stroke="${c}" stroke-width="0.9"/>`;
  }
}

module.exports = { deviceSvg };
